import { render, staticRenderFns } from "./AddressInfo.vue?vue&type=template&id=2bcc5ee2&"
import script from "./AddressInfoVue.ts?vue&type=script&lang=ts&"
export * from "./AddressInfoVue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports